(function () {
  'use strict';

  angular
    .module('web2print')
    .filter('price', price);

  function price ($filter) {
    return priceFilter;

    function priceFilter (input, forceZeros) {
      if (!_.isNumber(input)) return;

      // prices are integers to avoid float rounding errors, divide by 100 for presentation.
      input /= 100;

      if ((input + '').indexOf('.') !== -1 || !!forceZeros) {
        return $filter('number')(input, 2);
      } else {
        return $filter('number')(input, 0);
      }
    }
  }
})();
